module.exports = "build/assets/mobileFrontPapers.a2b4d7b2.png";